<template><div>
	<div class="mask"></div>
	<div class="dig setting-dig" style="height: 300px" v-dlgdrag>
        <div class="dig_title clearFix">
            <div class="fl"><b class="mark_choose"></b>设置</div>
            <Icon class="fr" type="close-round" @click.native="dialogClose"/>
        </div>
		<div v-if="errmsg" class="dig-main clearFix" style="color:#f00;font-size:14px;">{{errmsg}}</div>
		<div v-else class="dig-main clearFix" style="margin-top: 20px;">
			<div class="form-grounp clearFix">
				<label class="fl control-label">页面标题</label>
				<div class="col-sm fl">
					<Input v-model="settings.navigationBarTitleText" size="large" style="width:235px;"></Input>
				</div>
			</div>
			<div class="form-grounp clearFix">
				<label class="fl control-label">标题栏颜色</label>
				<div class="col-sm fl">
					<Input :value="settings.navigationBarBackgroundColor" :disabled="true" size="large" style="width:235px;"></Input>
					<ColorPicker2 v-model="settings.navigationBarBackgroundColor" format="single" size="large"/>
				</div>
			</div>
			<div class="form-grounp clearFix">
				<label class="fl control-label">文字颜色</label>
				<div class="col-sm fl">
					<RadioGroup size="large" v-model="settings.navigationBarTextStyle" type="button" style="float:left">
						<Radio label="white">白色</Radio>
						<Radio label="black">黑色</Radio>
					</RadioGroup>
				</div>
			</div>
			<!--div class="form-grounp clearFix">
				<label class="fl control-label">内页风格</label>
				<div class="col-sm fl">
					<Input :value="settings.insidepage_themecolor" :disabled="true" size="large" style="width:235px;"></Input>
					<ColorPicker2 v-model="settings.insidepage_themecolor" size="large"/>
				</div>
			</div-->
		</div>
		<div class="dig-footer clearfix" style="position: absolute;left: 0;right: 0px;bottom: 0;padding: 5px 40px 20px 40px;">
			<div class="setting-btn"><a @click.stop="settingsSave">保存</a></div>
		</div>
    </div>
</div></template>

<script>
import jGlobal from '@/global';
import EventBus from '@/common/events';
import Dlgdrag from '@/common/dlgdrag';
import ColorPicker2 from '@/components/colorpicker';

let navbarSet = function(param = {}){
	let that = this;
	jGlobal.xhrPost('page/styles', param, res => {
		if (res.result == 'ERROR') {
			that.errmsg = res.data.errmsg;
			return false
		}

		let jsndata = res.data || {};
		if (! $.isEmptyObject(jsndata)) {
			that.settings = Object.assign(that.settings, jsndata)
		} else if (! $.isEmptyObject(param)) that.dialogClose()
	}, err => console.error(err))
};

export default
{
	mixins: [Dlgdrag],
	data (){
		return {
			settings: {
				navigationBarTextStyle: 'white',
				navigationBarTitleText: '',
				navigationBarBackgroundColor: '#000',
				insidepage_themecolor: '#c71f3b',
			},
			errmsg: '',
		}
	},
	created (){
		// Get 'settings'
		navbarSet.call(this)
	},
	methods: {
		dialogClose (){
			EventBus.$emit("hide_setting")
		},
		settingsSave (){
			navbarSet.call(this, {
				type: 'update',
				settings: this.settings
			})
		}
	},
	components: {ColorPicker2},
}
</script>

<style type="text/css">.setting-dig .sp-replacer {position: absolute;right: 1px;top: 1px;background: #fff;border-top-right-radius: 4px;border-bottom-right-radius: 4px;padding: 7px 4px;border: none!important;}</style>
<style scoped>
.clearFix:after {content: '';clear: both;width: 0;height: 0;display: block;}
.mask {width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);position: fixed;left: 0;top: 0;z-index: 10000;}
.supercate-set {width: 100%;overflow: hidden;}
.supercate-set > li {float: left;width: 100%;}
.supercate-set label.ctitle {display: inline-block;float: left;height: 32px;line-height: 32px;width: 70px;}
.supercate-set .content {float: left;line-height: 32px;}
.inprename {border: 1px solid #e9e9e9;border-radius: 3px;height: 25px;margin-top: 1px;padding: 0 3px;text-align: center;width: 72px;}
span.empty {color: #f00;display: block;height: 30px;line-height: 30px;margin: 0 auto;width: 96%;}
.dig  {width: 880px;height: 100%;background-color: #fff;position: fixed;z-index: 10001;min-height: 400px;}
.dig .dig_title {width: 100%;height: 64px;line-height: 60px;padding: 0 15px;font-size: 14px;}        
.dig .dig_title.fr {cursor: pointer;}
.dig .dig_title.fr :hover {transform: rotate(720deg);}                
.dig .dig_title.fr :before {height: 35px;line-height: 35px;}
.dig .dig_operate {margin: 0 auto;}        
.setting-dig {width: 400px;min-height: 300px;height: 300px;}	
.dig_title {border-bottom: 1px solid #dddee1;border-top: 4px solid #2d8cf0;background-color: #fafafa;font-size: 14px;color: #2d8cf0;}
.dig_title .fr {padding: 5px;margin-top: 17px;color: #bfbfbf;cursor: pointer;}		
.dig-main {position: absolute;left: 0;right: 0px;top: 64px;bottom: 0;padding: 0 15px;}
.form-grounp {margin-bottom: 10px;}
.form-grounp .control-label {line-height: 36px;width: 80px;color: #888;font-size: 14px;}
.form-grounp .col-sm {position: relative;}		
.setting-btn {text-align: center;}
.setting-btn a {display: inline-block;line-height: 40px;width: 70%;color: #fff;font-size: 14px;background-color: #2d8cf0;border-radius: 4px;margin-top: 10px;}
.ivu-tabs-tabpane {padding-left:20px;}
</style>


// WEBPACK FOOTER //
// setting.vue?57655280